import { useCallback } from 'react';

import { SellerService } from '@/api';

export interface ManualCheck {
  cName: string;
  isAvailable: boolean;
  domainName: string;
}

export function useCheckCNameAvailability(): (
  cName: string,
) => Promise<ManualCheck | undefined> {
  return useCallback(
    async (cName: string): Promise<ManualCheck | undefined> => {
      const response = await SellerService.getDomainNameFromCNameQuery({
        cName,
      });

      if (response.failure) {
        return undefined;
      }

      return {
        cName,
        isAvailable: response.value.available,
        domainName: response.value.domainName,
      };
    },
    [],
  );
}
